import React from "react";
import { eagle_icon } from "../../assets/images";

// Loading screen component
const LoadingScreen = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-white z-50">
      <img
        src={eagle_icon}
        alt="Logo"
        className="w-32 h-22 animate-pulse transition-transform duration-1000 ease-in-out scale-100 hover:scale-110"
      />
    </div>
  );
};

export default LoadingScreen;

